export default {
    "created": "Documentatia a fost creată cu succes.",
    "updated": "Documentatia a fost actualizată cu succes.",
    "deleted": "Documentatia a fost ștearsă cu succes.",
    "restored": "Documentatia a fost restaurată cu succes.",
}
